'use client';

import { useMemo } from 'react';
import { useGetAvailableDataRangeQuery } from 'src/api/redux';
import {
  AvailableDataRange,
  mapCategoryToDataRange,
} from 'src/utils/quarterUtils';

/**
 * Available data window for the Average Reimbursement quarter picker. Sourced
 * from the backend `available-data-range` endpoint (`reimbursement` category),
 * which is pinned to a narrower window server-side than the other Territory
 * Analytics insights (`useAvailableDataRange`).
 *
 * Returns `undefined` while the range is loading or when the endpoint has no
 * data (a rare data outage). Callers should render a loading state rather than
 * a fabricated window.
 */
const useReimbursementDataRange = (): AvailableDataRange | undefined => {
  const { data } = useGetAvailableDataRangeQuery();

  return useMemo(() => mapCategoryToDataRange(data?.reimbursement), [data]);
};

export default useReimbursementDataRange;
